import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useGlobalContext } from "../provider";

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true
    sx: true
    sm: true
    md: true
    lg: true
    xl: true
    xl2: true
  }

  interface CommonColors {
    mainBg: string
    subHeaderBg: string
    footerBg: string
    sectionBg: string

    firstBorder: string

    firstButtonBg: string
    secondButtonBg: string

    firstColor: string
    secondColor: string
    thirdColor: string
    fourthColor: string
  }

  // interface Palette {
  //   mainBg: PaletteColor;
  // }

  // interface PaletteOptions {
  //   mainBg: PaletteColorOptions;
  // }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    // mainBg: true;
  }
}

const MuiThemeProvider = ({ children }: any) => {
  const [globalState]: GlobalContextType = useGlobalContext();

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sx: 450,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        xl2: 1536,
      }
    },
    palette: {
      common: {
        black: '#000',
        white: '#fff',

        mainBg: '#ffffff',
        subHeaderBg: "#36454F",
        footerBg: "#36454F",
        sectionBg: '#f0f6ff',

        firstBorder: "#06117626",

        firstButtonBg: "#0056d2",
        secondButtonBg: "#50C878",

        firstColor: "#333333",
        secondColor: "#ffffff",
        thirdColor: "#0056d2",
        fourthColor: "#d32f2f",

        // #FFFFFF //white
        // #a9a9a9 //Dark gray
        // #FFC0CB //Pink
        // #87CEEB //Sky Blue
        // #50C878 //Emerald Green
        // #36454F //Near Black
      },

      // mainBg: { main: '#141416', light: '#24262f', contrastText: "#fff" },
      // primary: { main: '#fff', light: '#f55b00', dark: '#1e0500', contrastText: 'rgba(0,0,0,0.87)' },
    },
    typography: {
      allVariants: { color: "#333333" },
      htmlFontSize: 16,
      fontSize: 16,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 800,

      fontFamily: globalState.lang === "jp" ? "NotoSansJP, ui-sans-serif, system-ui" : "ui-sans-serif, system-ui"
    },
  })

  theme.typography.h1 = {
    ...theme.typography.h1,

    fontSize: 50,
    fontWeight: 700,

    [theme.breakpoints.down("lg")]: {
      fontSize: 45,
    },

    [theme.breakpoints.down("md")]: {
      fontSize: 35,
    }
  }

  theme.typography.h2 = {
    ...theme.typography.h2,

    fontSize: 35,
    fontWeight: 600,

    [theme.breakpoints.down("lg")]: {
      fontSize: 30,
    },

    [theme.breakpoints.down("md")]: {
      fontSize: 25,
    }
  }

  theme.typography.h3 = {
    ...theme.typography.h3,

    fontSize: 30,
    fontWeight: 600,

    [theme.breakpoints.down("lg")]: {
      fontSize: 26,
    },

    [theme.breakpoints.down("md")]: {
      fontSize: 22,
    }
  }

  theme.typography.h5 = {
    ...theme.typography.h5,

    fontSize: 20,
    fontWeight: 500,

    [theme.breakpoints.down("lg")]: {
      fontSize: 18,
    },

    [theme.breakpoints.down("md")]: {
      fontSize: 16,
    }
  }


  theme.typography.h6 = {
    ...theme.typography.h6,

    fontSize: 18,
    fontWeight: 500,

    [theme.breakpoints.down("lg")]: {
      fontSize: 17,
    },

    [theme.breakpoints.down("md")]: {
      fontSize: 15,
    }
  }

  theme.typography.body1 = {
    ...theme.typography.body1,

    fontSize: 16,
    fontWeight: 400,

    [theme.breakpoints.down("lg")]: {
      fontSize: 15,
    },

    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    }
  }

  theme.typography.body2 = {
    ...theme.typography.body2,

    fontSize: 15,
    fontWeight: 400,

    [theme.breakpoints.down("lg")]: {
      fontSize: 14,
    },

    [theme.breakpoints.down("md")]: {
      fontSize: 13,
    }
  }

  theme.typography.subtitle1 = {
    ...theme.typography.subtitle1,

    fontSize: 14,
    fontWeight: 400,

    [theme.breakpoints.down("lg")]: {
      fontSize: 13,
    },

    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    }
  }

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  )
}

export { MuiThemeProvider };